export const checkTypeOfRound = (transactionType: string) => {
  const type = transactionType.toLocaleLowerCase();
  return (
    // type !== "conversion" &&
    type !== "redemption" &&
    type !== "update_class" &&
    type !== "esoppool"
  );
};
